<div class="row" [style.justify-content]="'space-between'">
  <div class="col-md-3">
    <h2 [style.marginBottom.px]="0">File Metadata</h2>
  </div>
  <div>
    <span class="switch-label">View Tagged Items Only</span>
    <label class="switch" [ngStyle]="{ 'margin': '0px 12px 0px 8px', 'float': 'right' }">
      <input type="checkbox" (change)='tagChange()' [(ngModel)]="taggedOnly">
      <span class="slider"></span>
    </label>
  </div>
</div>

<app-search-analytics (onClick)="onChartClick($event)" [analytics]="fileAnalytics"></app-search-analytics>

<!-- Active search filters -->
@if ((activeSearchFilters | json) !== '{}') {
  <div [style.margin-bottom.px]="16" class="row">
    <div class="search-filters col-sm-12">
      <p>search filters:</p>
      @for (field of activeSearchFilters | keyvalue; track field) {
        @if (field.value) {
          <div class="active-search-filter">
            <div><strong>{{ aliases[field.key] }}:</strong> {{ field.value.year ? formatDate(field.value) : field.value }}</div>
            <div (click)="resetFormField(field.key)" class="filter-x"><i class="fas fa-times"></i></div>
          </div>
        }
      }
      <p (click)="resetForm()" class="clear-button">clear</p>
    </div>
  </div>
}

<!-- Quick search: file name, path, extension or hash -->
<form class="quick-search" [formGroup]="taggedOnly ? taggedSearchForm : searchForm" (ngSubmit)="onSubmit()" novalidate>
  <input type="search" class="form-control form-control-sm" formControlName="search" aria-label="Quick search"
    placeholder="Search file name, path, extension or hash">
  <button type="submit" class="btn btn-sm btn-primary"><i class="fas fa-search"></i> Search</button>
</form>

<!-- Quick filters -->
<div class="quick-filters">
  @if (fileAnalytics?.topExtensions?.length) {
    <div class="quick-filter-group">
      <span class="quick-filter-label">Extension</span>
      @for (ext of fileAnalytics.topExtensions.slice(0, 8); track ext.extension) {
        <button type="button" class="btn btn-xs btn-outline-secondary" (click)="extensionFilter(ext.extension)">
          {{ ext.extension || 'none' }} <span class="quick-filter-count">{{ ext.count | number }}</span>
        </button>
      }
    </div>
  }
  <div class="quick-filter-group">
    <span class="quick-filter-label">Size</span>
    @for (range of sizeRanges; track range.label) {
      <button type="button" class="btn btn-xs btn-outline-secondary" (click)="sizeRangeFilter(range)">{{ range.label }}</button>
    }
  </div>
  <div class="quick-filter-group">
    <span class="quick-filter-label">Modified</span>
    @for (range of dateRanges; track range.label) {
      <button type="button" class="btn btn-xs btn-outline-secondary" (click)="dateRangeFilter(range.days)">{{ range.label }}</button>
    }
  </div>
</div>

<alert></alert>

<div>
  <div class="info-row">
    <div class="btn-group btn-group-sm table-text-size" role="group" [title]="'Table text size: ' + tableFontSize + 'px'">
      <button type="button" class="btn btn-outline-secondary" aria-label="Decrease table text size"
        [disabled]="tableFontSize <= fontSizeRange.min" (click)="changeTableFontSize(-1)">A&minus;</button>
      <span class="btn btn-outline-secondary font-size-value" aria-hidden="true">{{ tableFontSize }}px</span>
      <button type="button" class="btn btn-outline-secondary" aria-label="Increase table text size"
        [disabled]="tableFontSize >= fontSizeRange.max" (click)="changeTableFontSize(1)">A+</button>
    </div>
    @if (!loading) {
      <span>{{ totalRecords | number }} records found</span>
    }
    @if (loading) {
      <span><i class="loading-icon fas fa-spinner"></i>fetching</span>
    }

    @if (!loading && totalRecords >= PAGINATION_RECORD_LIMIT) {
      <span> - First {{ PAGINATION_RECORD_LIMIT | number }} records being shown </span>
      <a [routerLink]="[]" (click)="preventDefault($event)" class="tip"><i class="fa fa-question-circle" aria-hidden="true"></i><span>
      <pre>
        If you are not able to find the record you are looking for, try narrowing down results
      by using the search fields.</pre>
    </span></a>
  }
</div>

@if (searchApplied) {
  <div>
    <br />
  </div>
}
<div class="filter form-row" [style.justify-content]="'space-between'">
  <div class="col-md-3" [style.display]="'flex'">
    <form [formGroup]="recordLimitForm" class="float-left limitform" (ngSubmit)="onSubmit()" novalidate>
      <select class="form-control form-control-sm" formControlName="recordlimit"
        (change)="updateRecords($event.target.value)">
        @for (option of pagination['options']; track option) {
          <option value="{{option.key}}">{{option.value}}</option>
        }
      </select>
    </form>

    <!-- Search form dropdown -->
    <div ngbDropdown #searchform="ngbDropdown" [open]="dropdownOpen">
      <button ngbDropdownToggle [style.marginLeft.px]="16" type="button" class="btn btn-primary btn-sm dropdown-toggle">
        <i class="fas fa-search"></i> Search
      </button>
      <div ngbDropdownMenu class="search-dropdown-container">
        <div class="top-right-wrapper">
          <app-search-guidelines></app-search-guidelines>
          <div class="x-button" (click)="searchform.close()"><i class="fas fa-times"></i></div>
        </div>
        <form class="advance-search-form" [formGroup]="taggedOnly ? taggedSearchForm : searchForm" (ngSubmit)="onSubmit(); searchform.close()" novalidate>
          <h3>Filter Search</h3>
          <div class="row basicform">
            <!-- File Name -->
            <div class="col-md-9">
              <input type="text" class="form-control form-control-sm {{(formLoading)? 'loading' : ''}}"
                formControlName="fileName" placeholder="File Name">
            </div>
            <!-- File Extension -->
            <div class="col-md-3">
              <input type="text" class="form-control form-control-sm file-ext" formControlName="extension"
                placeholder="File Extension">
              <label class="no-extension"><input type="checkbox" formControlName="noExtension"> No extension</label>
            </div>
          </div>
          <div class="row">
            <!-- File Name -->
            <div class="col-md-6">
              <input type="text" class="form-control form-control-sm {{(formLoading)? 'loading' : ''}}"
                formControlName="mediaName" placeholder="Media Name">
            </div>
            <!-- Path -->
            <div class="col-md-6">
              <input type="text" class="form-control form-control-sm" formControlName="filePath" placeholder="Path">
            </div>
          </div>
          <div class="adform">
            <div class="row">
              <!-- Hash -->
              <div class="col-md-6">
                <input type="text" class="form-control form-control-sm" formControlName="hash" placeholder="Hash">
              </div>
              <!-- Minimum Size -->
              <div class="col-md-3">
                <input type="text" class="form-control form-control-sm" formControlName="minSize"
                  placeholder="Minimum size (bytes)">
              </div>
              <!-- Maximum Size -->
              <div class="col-md-3">
                <input type="text" class="form-control form-control-sm" formControlName="maxSize"
                  placeholder="Maximum size (bytes)">
              </div>

            </div>
            <hr />
            <div class="row">
              <!-- Oldest Created Date -->
              <div class="col-md-6 form-group input-date">
                <label>Oldest created date</label>
                <input class="form-control form-control-sm" formControlName="minCreateDate" placeholder="mm/dd/yyyy"
                  ngbDatepicker [minDate]="minDate" [maxDate]="maxDate" #ocdp="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar" (click)="ocdp.toggle()" type="button"><i
                class="fa fa-calendar"></i></button>
              </div>
              <!-- Newest Created Date -->
              <div class="col-md-6 form-group input-date">
                <label>Newest created date</label>
                <input class="form-control form-control-sm" formControlName="maxCreateDate" placeholder="mm/dd/yyyy"
                  ngbDatepicker [minDate]="minDate" [maxDate]="maxDate" #ncdp="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar" (click)="ncdp.toggle()" type="button"><i
                class="fa fa-calendar"></i></button>
              </div>
            </div>
            <div class="row">
              <!-- Oldest Modify Date -->
              <div class="col-md-6 form-group input-date">
                <label>Oldest modify date</label>
                <input class="form-control form-control-sm" formControlName="minModifyDate" placeholder="mm/dd/yyyy"
                  ngbDatepicker [minDate]="minDate" [maxDate]="maxDate" #omdp="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar" (click)="omdp.toggle()" type="button"><i
                class="fa fa-calendar"></i></button>
              </div>
              <!-- Newest Modify Date -->
              <div class="col-md-6 form-group input-date">
                <label>Newest modify date</label>
                <input class="form-control form-control-sm" formControlName="maxModifyDate" placeholder="mm/dd/yyyy"
                  ngbDatepicker [minDate]="minDate" [maxDate]="maxDate" #nmdp="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar" (click)="nmdp.toggle()" type="button"><i
                class="fa fa-calendar"></i></button>
              </div>
            </div>
            <div class="row">
              <!-- Oldest Acccess Date -->
              <div class="col-md-6 form-group input-date">
                <label>Oldest access date</label>
                <input class="form-control form-control-sm" formControlName="minAccessDate" placeholder="mm/dd/yyyy"
                  ngbDatepicker [minDate]="minDate" [maxDate]="maxDate" #nodp="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar" (click)="nodp.toggle()" type="button"><i
                class="fa fa-calendar"></i></button>
              </div>
              <!-- Newest Access Date -->
              <div class="col-md-6 form-group input-date">
                <label>Newest access date</label>
                <input class="form-control form-control-sm" formControlName="maxAccessDate" placeholder="mm/dd/yyyy"
                  ngbDatepicker [minDate]="minDate" [maxDate]="maxDate" #nadp="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar" (click)="nadp.toggle()" type="button"><i
                class="fa fa-calendar"></i></button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <button type="submit" class="btn btn-sm btn-primary">Search</button>
                <button type="reset" class="btn btn-sm btn-outline-secondary" (click)="resetForm(); searchform.close()">Reset</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Saved searches (this browser, this project) -->
    <div ngbDropdown #savedDropdown="ngbDropdown" autoClose="outside">
      <button ngbDropdownToggle [style.marginLeft.px]="8" type="button" class="btn btn-outline-primary btn-sm dropdown-toggle">
        <i class="fas fa-bookmark"></i> Saved
      </button>
      <div ngbDropdownMenu class="saved-searches-menu">
        <form class="saved-search-form" (ngSubmit)="saveSearch()">
          <input type="text" class="form-control form-control-sm" name="savedSearchName" [(ngModel)]="savedSearchName"
            placeholder="Name this search" aria-label="Saved search name" maxlength="80">
          <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </form>
        @for (saved of savedSearches; track saved.id) {
          <div class="saved-search-item">
            <div class="saved-search-name" [title]="saved.name">
              {{ saved.name }}
              <small>{{ saved.createdAt | date:'short' }}{{ saved.taggedOnly ? ' · tagged only' : '' }}</small>
            </div>
            <button type="button" class="btn btn-link btn-sm" [attr.aria-label]="'Run saved search ' + saved.name"
              title="Run" (click)="runSavedSearch(saved); savedDropdown.close()"><i class="fas fa-play"></i></button>
            <button type="button" class="btn btn-link btn-sm text-danger" [attr.aria-label]="'Delete saved search ' + saved.name"
              title="Delete" (click)="deleteSavedSearch(saved)"><i class="fas fa-trash"></i></button>
          </div>
        } @empty {
          <div class="saved-search-empty">No saved searches</div>
        }
      </div>
    </div>
  </div>
  @if (totalRecords && totalRecords > pagination.limit) {
    <div class="pagination-layout pager-row col-md-6">
      <pagination-controls maxSize="7" directionLinks="true" (pageChange)="pageChanged($event)">
      </pagination-controls>
      <form class="page-jump" (ngSubmit)="jumpToPage(pageInput.value); pageInput.value = ''">
        <input #pageInput type="number" min="1" [max]="pageCount" class="form-control form-control-sm"
          aria-label="Page number" [placeholder]="'1–' + pageCount">
        <button type="submit" class="btn btn-sm btn-outline-primary">Go</button>
      </form>
    </div>
  }
  <div class="col-md-3">
    <button class="btn btn-sm btn-outline-success float-right download-btn" (click)="download()" [disabled]="!files.length || (!taggedOnly && !checkedRecords.length)"
      title="Download Records">
      @if (!downloadStarted) {
        <i class="fa fa-fw fa-download"></i>
      }
      @if (downloadStarted) {
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      }
    </button>
    @if (!taggedOnly) {
      <form class="tagform float-right" novalidate>
        <button type="submit" class="btn btn-sm btn-secondary" [disabled]="checkedRecords.length === 0"
          (click)="tagItems()">Tag Items<i [style.color]="'white'" [style.margin-left.px]="8" class="fas fa-tag"></i>
        </button>
      </form>
    }
    @if (taggedOnly) {
      <form class="tagform float-right" novalidate>
        <button type="submit" class="btn btn-sm btn-secondary" [disabled]="checkedRecords.length === 0"
          (click)="untagItems()">Untag Items <i [style.color]="'white'" [style.margin-left.px]="8" class="fas fa-tag"></i>
        </button>
      </form>
    }
  </div>
</div>
<div class="table-responsive results-table">
  <table class="table table-bordered table-striped table-sm table-hover" id="dataTable" width="100%" cellspacing="0"
    [style.font-size.px]="tableFontSize">
    <thead>
      <tr>
        <th width="14" class="sort-na" [resizeColumn]="true">
          <input class="float-left" type="checkbox" [disabled]="loading || !files || files.length === 0" [ngModel]="allSelected" (change)="checkAllRows($event);" />
        </th>
        <th width="14" title="Tagged?" class="sort-na" [resizeColumn]="true"><i class="fas fa-tag"></i></th>
          <th width="50" [resizeColumn]="true" (click)="sort(sortMethodTypes.MEDIA)" [ngClass]="{'fa-sort': sortMethod != sortMethodTypes.MEDIA, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.MEDIA && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.MEDIA && sortDirection === 'DESC')}">Media Name</th>
          <th width="50" [resizeColumn]="true" (click)="sort(sortMethodTypes.EXTENSION)" [ngClass]="{'fa-sort': sortMethod != sortMethodTypes.EXTENSION, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.EXTENSION && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.EXTENSION && sortDirection === 'DESC')}">Extention</th>
          <th width="150" [resizeColumn]="true" (click)="sort(sortMethodTypes.FILENAME)" [ngClass]="{'fa-sort': sortMethod != sortMethodTypes.FILENAME, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.FILENAME && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.FILENAME && sortDirection === 'DESC') }">Filename</th>
          <th width="70" [resizeColumn]="true" (click)="sort(sortMethodTypes.SIZE)" [ngClass]="{'fa-sort': sortMethod != sortMethodTypes.SIZE, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.SIZE && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.SIZE && sortDirection === 'DESC') }">Size (bytes)</th>
          <th width="350" [resizeColumn]="true" class="" (click)="sort(sortMethodTypes.PATH)" [ngClass]="{'fa-sort': sortMethod != sortMethodTypes.PATH, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.PATH && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.PATH && sortDirection === 'DESC') }">File Path</th>
          <th width="70" [resizeColumn]="true" class="text-right" (click)="sort(sortMethodTypes.CREATED_DATE)" [ngClass]="{'fa-sort': sortMethod != sortMethodTypes.CREATED_DATE, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.CREATED_DATE && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.CREATED_DATE && sortDirection === 'DESC') }">Created Date</th>
          <th width="70" [resizeColumn]="true" class="text-right" (click)="sort(sortMethodTypes.MODIFY_DATE)" [ngClass]="{'fa-sort': sortMethod != sortMethodTypes.MODIFY_DATE, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.MODIFY_DATE && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.MODIFY_DATE && sortDirection === 'DESC') }">Modify Date</th>
          <th width="70" [resizeColumn]="true" class="text-right" (click)="sort(sortMethodTypes.ACCESS_DATE)" [ngClass]="{'fa-sort': sortMethod != sortMethodTypes.ACCESS_DATE, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.ACCESS_DATE && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.ACCESS_DATE && sortDirection === 'DESC') }">Access Date</th>
          <th width="200" [resizeColumn]="true" class="" (click)="sort(sortMethodTypes.HASH)" [ngClass]="{'fa-sort': sortMethod != sortMethodTypes.HASH, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.HASH && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.HASH && sortDirection === 'DESC')}">Hash</th>
        <th title="Deleted?" width="14" [resizeColumn]="true" class="sort-na no-space"><i class="fas fa-trash"></i></th>
      </tr>
    </thead>
    <tbody>
      @if (loading || !files || files.length == 0) {
        <tr>
          <td [attr.colspan]="12" class="loading text-center">
            <span class="" [innerHTML]="msg"></span>
          </td>
        </tr>
      }
      @for (item of files | paginate: {
        itemsPerPage: pagination.limit,
        currentPage: currentPage,
        totalItems: totalRecords >= PAGINATION_RECORD_LIMIT ? PAGINATION_RECORD_LIMIT : totalRecords
        }; track item) {
        <tr data-id="{{item.id}}">
          <td class="text-center">
            <input type="checkbox" id={{item.id}} [checked]="isRecordChecked(item.id)"
              (input)="toggleRecordCheck($event, item.id)" />
          </td>
          <td>@for (tag of item.tags; track tag.id) {
            <i class="fas fa-tag mr-1" [title]="tag.name" [style.color]="tag.color"></i>
          } @empty {
            @if (item.tagged) {
              <i title="tagged" class="fas fa-tag"></i>
            }
          }</td>
          <td class="ellepsis" title="{{item.media}}">{{item.media}}</td>
          <td class="ellepsis" title="{{item.extension}}">{{item.extension}}</td>
          <td class="ellepsis" title="{{item.fileName}}" [style.white-space]="'pre'">{{item.fileName}}</td>
          <td>{{ sizeInBytes(item.size) }}</td>
          <td class="ellepsis" title="{{item.filePath}}">{{item.filePath}}</td>
          <td class="text-right" title="{{item.createDate * 1000 | date:'MMM d, y, HH:mm:ss' }}">
          {{item.createDate * 1000 | date:'MM/dd/yy' }}</td>
          <td class="text-right" title="{{item.modifyDate * 1000 | date:'MMM d, y, HH:mm:ss' }}">
          {{item.modifyDate * 1000 | date:'MM/dd/yy' }}</td>
          <td class="text-right" title="{{item.accessDate * 1000 | date:'MMM d, y, HH:mm:ss' }}">
          {{item.accessDate * 1000 | date:'MM/dd/yy' }}</td>
          <td>{{item.hash}}</td>
          <td>@if (item.deleted) {
            <i title="deleted" class="deleted-icon fas fa-trash"></i>
          }</td>
        </tr>
      }
    </tbody>
  </table>
</div>
@if (totalRecords && totalRecords > pagination.limit) {
  <div class="pagination-layout">
    <pagination-controls maxSize="7" (pageChange)="pageChanged($event)" class="my-pagination">
    </pagination-controls>
  </div>
}
</div>